import { IInquiryResponse } from '@interfaces/inquiries';
import { TSupplementResponseStatus } from '@interfaces/supplements';

export const getIsLastOneThatNeedsInfo = (data: IInquiryResponse) => {
  const needInfoItems = data.medicationInquiriesDto.filter(
    item => item.supplementInquiryStatusId === TSupplementResponseStatus.NeedsInfo,
  );

  return needInfoItems.length === 1;
};

export const getHasUnseenResponses = (data: IInquiryResponse) =>
  data.medicationInquiriesDto.some(
    item => item.supplementInquiryStatusId === TSupplementResponseStatus.New,
  );
